import { render, staticRenderFns } from "./UserWalletTransactionsComponent.vue?vue&type=template&id=0d2d445a&"
import script from "./UserWalletTransactionsComponent.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports